import type { $Enums } from '@prisma/client'
import type { IUseDuration } from '../hooks/duration'
import type { IUsePayStep } from '../hooks/payStep'

import { api } from '@/utils/api'

/**
 * @description: 仅用作类型提示，不做任何请求
 */
function useProductsList({ appName }: { appName: $Enums.SubLogAppName }) {
  const { data, isInitialLoading, refetch, isLoading, isFetching } =
    api.product.getProductsList.useQuery({ appName }, {})
  return { productsList: data?.productsList || [] }
}

export type TUseProductsList = ReturnType<typeof useProductsList>

export type TProductsList = TUseProductsList['productsList']

export type TProduct = TProductsList[number]

export enum EDuration {
  MONTHLY = 1,
  YEARLY = 12,
}

export enum EProductType {
  FREE = 'Free',
  BASIC = 'Basic',
  PRO = 'Pro',
  UNLIMITED = 'Unlimited',
  ULTIMATE = 'Ultimate',
}

export enum EPaidProductType {
  BASIC = 'Basic',
  PRO = 'Pro',
  UNLIMITED = 'Unlimited',
  ULTIMATE = 'Ultimate',
}

export interface ISubCreateProps {
  appName: $Enums.SubLogAppName
  pricesId: string[]
  // currencyInfo: TUseGetCurrency['currencyInfo']
  userId: string
  productPriceList: TProduct[]
  customerId?: string
  platformName?: string
}

export interface IPlansInitialValue {
  productList: TProductsList
  effectiveUserGroup?: string
  onUpgradeSuccess?: () => void
  onCurrentDurationChange?: IUseDuration['onCurrentDurationChange']
  size?: 'large' | 'middle' | 'small'
  appName: $Enums.SubLogAppName
  onChangeStep?: IUsePayStep['onChangeStep']
  isModal: boolean
  isActive?: boolean
  isAnonymousPayment?: boolean
}

export interface IInnerProps {
  className?: string
  cardClassName?: string
  ulClassName?: string
  durationClassName?: string
}

export interface ICommonPlansBlockProps
  extends IPlansInitialValue,
    IInnerProps {}

export enum EPayButtonStatus {
  start = 'start',
  current = 'current',
  upgrade = 'upgrade',
  disabled = 'disabled',
}
